import axios from "../request";
import UserMgr from "@/mgr/UserMgr";

// 辅助函数：添加 token 到参数
const addTokenToParams = (params = {}) => {
    const userInfo = UserMgr.inst.userInfo;
    return {
        ...params,
        userid: +userInfo.userid || 0,
        token: userInfo.token || "",
    };
};

export default {
    getResUrl(params) {
        return axios.get("/huashi/get_file_url", {
            params: addTokenToParams(params),
        });
    },
    getProduct(params) {
        return axios.post("/huashi/get_product", addTokenToParams(params));
    },
};
